(() => {
  const bar = document.querySelector('[data-hm-sticky]');
  if (!bar) return;
  const form = document.getElementById(bar.dataset.formId);
  const mainBtn = form && form.querySelector('[type="submit"]');
  if (!mainBtn) return;
  bar.hidden = false;
  const io = new IntersectionObserver(([e]) => {
    const below = e.boundingClientRect.top < 0;
    bar.classList.toggle('is-visible', !e.isIntersecting && below);
  });
  io.observe(mainBtn);
  bar.querySelector('[data-hm-sticky-btn]').addEventListener('click', () => {
    if (mainBtn.getAttribute('aria-disabled') === 'true' || mainBtn.disabled) {
      mainBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    mainBtn.click();
  });
  // Varyant değişince fiyatı güncelle (Dawn yayını)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const v = data && data.variant;
      if (!v) return;
      const priceEl = bar.querySelector('[data-hm-sticky-price]');
      if (priceEl) priceEl.textContent = new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(v.price / 100);
      const btn = bar.querySelector('[data-hm-sticky-btn]');
      btn.disabled = !v.available;
    });
  }
})();
